module.exports = __webpack_public_path__ + "static/media/book9_dappere-avonturier.47e86da5.png";